import {Component, OnInit, EventEmitter, Input, Output} from '@angular/core';
import {UsuarioService} from '../../../usuario/usuario.service';
import {Endereco} from '../../modelos/endereco';
import {PontoFisico} from '../../modelos/ponto-fisico';
import {Usuario} from '../../modelos/usuario';
import {Paginacao} from '../../modelos/paginacao';
import { CookieService } from 'angular2-cookie/core';

@Component({
  selector: 'app-form-ponto-fisico',
  templateUrl: './form-ponto-fisico.component.html',
  styleUrls: ['./form-ponto-fisico.component.css']
})
export class FormPontoFisicoComponent implements OnInit {

  @Input() pontoFisico: PontoFisico;
  @Input() modo: string;
  @Input() idCliente: number;

  @Output() pontoFisicoEvent: EventEmitter<string>;

  public cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public usuarios: Usuario[];
  public loading = false;

  constructor(private _usuarioService: UsuarioService,
			  private _cookieService: CookieService) {
    this.pontoFisicoEvent = new EventEmitter<string>();
    this.usuarios = new Array<Usuario>();
  }

  ngOnInit() {
    this.loading = true;
    this._usuarioService.obterUsuariosHttp(parseInt(this._cookieService.get('idCliente')))
      .subscribe((usuarios: Usuario[]) => {
        this.usuarios = usuarios;
        this.loading = false;
      });
  }

  emit(): void {
    this.pontoFisicoEvent.emit('formulário completo');
  }

  receberEndereco(endereco: Endereco) {
    this.pontoFisico.enderecoPontoFisico.endereco = endereco;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/form-ponto-fisico/form-ponto-fisico.component.ts